import MobileNav from '../plugins/mobileNav'

const initMobileBurgerNav = () => {
  const menuHolder = document.querySelector('body')
  const mobileNav = new MobileNav(menuHolder)
  mobileNav.init()
}

export default initMobileBurgerNav
